import { InspectionSession } from "./InspectionSession"

export class InspectionRegion {
    RegionId: string;
    SectionIds: String[];
    // Control Attribute
    RegionName: string;
    RegionChecked: Boolean;
    Sections: InspectionSession[]

    ElementIds: string[] = [];

    //[SectionId:string, SectionName: string, SectionChecked: boolean]; //Id Section e Name Section e Checked
}
